import { Injectable } from '@angular/core';
import { take, map } from 'rxjs/operators';
import { FirestoreService } from './firestore.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ConfigService {
  constructor(private firestore: FirestoreService) {}

  /**
   * Get configuration from firestore
   *
   * @param fullPath  Path to the configuration in firestore separated by dots ie: urls.google_review
   */
  async getConfiguration(fullPath: string) {
    const path = fullPath.split('.');
    const config = await this.firestore.doc(`welby_configuration/${path[0]}`).get().pipe(take(1)).toPromise();
    return config.data()[path[1]];
  }

  /**
   * Get feature toggle from firestore
   *
   * @param featureToggleName The name of the feature toggle to retrieve
   * @returns Observable<boolean> with the feature toggle value
   */
  getFeatureToggle(featureToggleName: string): Observable<boolean> {
    return this.firestore.doc$('welby_configuration/featureToggles').pipe(
      map(data => {
        if (data) {
          return data[featureToggleName] || false;
        }
        return false;
      })
    );
  }
}
